import Sales from "@repo/core/screens/Sales";

export default function SalesScreen() {
  return <Sales showCarrousel />;
}
